module.exports = __webpack_public_path__ + "static/media/SingleCoupon_image.267992e1.png";